import { useEffect } from "react";

const DEFAULT_TITLE = "Trustline Services — Reliable Cleaning Solutions";

const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const clip = (s, n = 158) => (s.length <= n ? s : `${s.slice(0, s.lastIndexOf(" ", n - 1))}…`);

const setHeadTag = (selector, create, apply) => {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  apply(el);
  return el;
};

// Sets title/description/og tags; optionally a canonical URL and JSON-LD structured data.
export function usePageMeta(title, description, { canonicalPath, jsonLd } = {}) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (!title) return undefined;
    const prevDesc = document.querySelector('meta[name="description"]')?.getAttribute("content") || "";
    const desc = clip(description || "");
    document.title = title;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", desc);
    const added = [];
    if (canonicalPath) {
      const url = `${window.location.origin}${canonicalPath}`;
      added.push(setHeadTag('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" }), (el) => { el.href = url; }));
      setMeta("property", "og:url", url);
    }
    if (ld) {
      added.push(setHeadTag('script[data-page-ld="1"]', () => {
        const s = document.createElement("script"); s.type = "application/ld+json"; s.dataset.pageLd = "1"; return s;
      }, (el) => { el.textContent = ld; }));
    }
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta("name", "description", prevDesc);
      added.forEach((el) => el.remove());
    };
  }, [title, description, canonicalPath, ld]);
}
